import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-terms-and-conditions-template',
  templateUrl: './terms-and-conditions-template.component.html',
  styleUrls: ['./terms-and-conditions-template.component.scss']
})
export class TermsAndConditionsTemplateComponent implements OnInit {
  @Input() domainName = 'online Portals';
  @Input() isOpenUrl = true;
  @Output() tncScrollEvent = new EventEmitter();

  privacyUrl;
  dnmUrl;
  contactUsUrl;

  constructor(
    private router: Router
  ) { }

  ngOnInit() {
    this.domainName = window.location.host;
    this.dnmUrl = `${this.domainName}/dnm/`;
    this.privacyUrl = `${this.domainName}/privacy-policy/`;
  }

  navigateToRoute(routeParam) {
    this.router.navigate([routeParam]);
  }

  handleTncScroll(event){
    this.tncScrollEvent.emit(event);
  }

}
